var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { attrs: { cols: "12" } },
    [
      _c("b-card", { staticClass: "pb-2" }, [
        _c(
          "div",
          { staticClass: "document-automation-request-header" },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center justify-content-between",
              },
              [
                _c("b-skeleton", {
                  staticClass: "mb-2",
                  attrs: { width: "10rem", height: "2rem" },
                }),
                _vm._v(" "),
                _c("b-skeleton", { attrs: { width: "4rem", height: "1rem" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c("b-skeleton", { attrs: { width: "20rem" } }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "document-automation-request-manage mt-3" },
          [
            _c(
              "div",
              { staticClass: "document-rows" },
              _vm._l(5, function (index) {
                return _c("b-skeleton", {
                  key: index,
                  staticClass: "mb-1",
                  attrs: { width: "100%", height: "1.5rem" },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "mt-3" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "5" } },
                  [
                    _c("b-skeleton", {
                      attrs: { width: "100%", height: "2.5rem" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }